import { ApplicantFromSearch } from '@core/typings/applicant.typing';
import { ApplicationStatuses } from '@core/typings/status.typing';
import { EmailOptionsModelForSave } from '@features/system-emails/email.typing';
import { SimpleGrantsAddress } from '@yourcause/common';

export interface InvitationRecord {
  invitationId: number;
  applicantName: string;
  applicantEmail: string;
  applicantId: number;
  invitationStatus: InvitationStatus;
  sentDate: string;
  scheduledDate: string;
  reminderDate: string;
  applicationCreatedDate: string;
  applicationId: number;
  applicationStatus: ApplicationStatuses;
  applicationIsArchived: boolean;
  applicationIsDraft: boolean;
  grantProgramId: number;
  grantProgramName: string;
  grantProgramCycleId: number;
  grantProgramCycleName: string;
  distributionListName: string;
  distributionListId: number;
  inviteStatusText?: string;
  openedText?: string;
  reminderSentText?: string;
  reminderEmailInactive: boolean;
  invitedBy: string;
}

export enum InvitationStatus {
  Scheduled = 1,
  Sent = 2
}

export interface SendInviteModalBaseResponse {
  programId: number;
  cycleId: number;
  emailOptionsModel: EmailOptionsModelForSave;
}

// v for after we upload the files v
export interface SendInviteIndividualForSave extends SendInviteModalBaseResponse {
  selectedApplicant: ApplicantFromSearch;
}

// v invite list v
export interface SendInviteListForSave extends SendInviteModalBaseResponse {
  distributionListId: number;
  scheduledDate: string;
  sendNow: boolean;
}

export interface InviteToExistingApplicant {
  applicantId: number;
  programId: number;
  cycleId: number;
  clientEmailTemplateId: number;
}

export interface InviteToNewApplicant {
  applicantFirstName: string;
  applicantLastName: string;
  applicantEmail: string;
  programId: number;
  cycleId: number;
  clientEmailTemplateId: number;
}

export interface DistributionListRecord {
  id: number;
  name: string;
  description: string;
  distributionListApplicantCount: number;
  createdBy: string;
  createdDate: string;
  updatedBy: string;
  updatedDate: string;
  impersonatedBy: string;
  createImpersonatedBy: string;
  deletable: boolean;
}


export interface DistributionListApplicant {
  distributionListApplicantId: number;
  applicantId: number;
  applicantName: string;
  applicantEmail: string;
  organizations: ApplicantOrg[];
}

export interface ApplicantOrg {
  id: number;
  nonprofitGuid: string;
  name: string;
  classification: number;
  address: SimpleGrantsAddress;
  phoneNumber: string;
  orgIdentification: string;
  isPrivateOrg: boolean;
}

export interface AvailableApplicant {
  applicant: {
    applicantId: number;
    applicantName: string;
    applicantEmail: string;
  };
  lastApplicationDate: string;
  lastAwardDate: string;
  organization: ApplicantOrg;
}

export interface AvailableApplicantForUi extends AvailableApplicant {
  applicantId: number;
}

export interface ScheduleRecord {
  distributionListScheduleId: number;
  scheduledDate: string;
  distributionListId: number;
  distributionListName: string;
  distributionListApplicantCount: number;
  grantProgramId: number;
  grantProgramCycleId: number;
  clientEmailTemplateId: number;
  createdBy: string;
  createdDate: string;
  createImpersonatedBy: string;
  updatedBy: string;
  updatedDate: string;
  impersonatedBy: string;
  isSent: boolean;
}

export interface ScheduleInvitee {
  id: number;
  name: string;
  email: string;
}

export interface SendApplicantInvitePayload {
  invitationId?: number;
  grantProgramId: number;
  grantProgramCycleId: number;
  clientEmailTemplateId: number;
  applicantId?: number;
  firstName: string;
  lastName: string;
  email: string;
  isEmployeeOfClient?: boolean;
  emailOptionsModel: EmailOptionsModelForSave;
  languageCulture: string;
}

export interface CreateInvitationListPayload {
  distributionListId: number;
  grantProgramId: number;
  grantProgramCycleId: number;
  clientEmailTemplateId: number;
  scheduledDate: string;
  emailOptionsModel: EmailOptionsModelForSave;
}

export interface InvitationApplicantHelpers {
  canApply: boolean;
  alreadyUsedInvite: boolean;
  grantProgramCycleIdOfNextInvitation: number;
  programIsArchived: boolean;
}

export interface InvitationDetail {
  invitationId: number;
  invitationUsed: boolean;
  grantProgramCycleId?: number;
  organizationId?: number;
}

export interface ApplicantFromDistributionList {
  firstName: string;
  lastName: string;
  email: string;
  isEmployee: boolean;
}
